import { SET_QUICK_SPECS_IDC } from '../actions/types';

export default function quickSpecsIDC(state = {}, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_QUICK_SPECS_IDC:
				return action.payload;

			// no default
		}
	}

	return state;
}
